export default function StatsModal({ open, hero, onClose }) {
  if (!open) return null;
  return (
    <div className="modal">
      <div className="modal-card">
        <h2>Hero Stats</h2>
        <div style={{display:'grid',gap:6,marginTop:8}}>
          <div><b>Name</b> {hero.name} — {hero.cls}</div>
          <div><b>STR</b> {hero.str} · <b>AGI</b> {hero.agi} · <b>INT</b> {hero.int}</div>
          <div><b>Weapon</b> {hero.weapon?.name} (Base {hero.weapon?.base ?? 4})</div>
          {hero.skill && <div><b>Skill</b> {hero.skill.name} — {hero.skill.kind.toUpperCase()} ({hero.skill.base})</div>}
        </div>
        <div className="row" style={{marginTop:10}}>
          <button className="btn primary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
